import { useBus, useAlert } from '@balm-ui'; // balm-ui/dist/balm-ui.js

export const $bus = useBus();
export const $alert = useAlert();
